import type { Meta, StoryFn } from '@storybook/react';

import { DangerButton } from '@pega/cosmos-react-core';
import type { DangerButtonProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/DangerButton',
  component: DangerButton
} as Meta;

export const DangerButtonDemo: StoryFn<DangerButtonProps> = (args: DangerButtonProps) => (
  <DangerButton label={args.label} primary={args.primary} disabled={args.disabled} />
);

DangerButtonDemo.args = {
  label: 'Proceed with caution',
  primary: true,
  disabled: false
};

DangerButtonDemo.argTypes = {
  label: { control: { type: 'text' } },
  primary: { control: { type: 'boolean' } },
  disabled: { control: { type: 'boolean' } }
};
